import { render, staticRenderFns } from "./contractItem.vue?vue&type=template&id=bcca0d0a"
import script from "./contractItem.vue?vue&type=script&lang=js"
export * from "./contractItem.vue?vue&type=script&lang=js"
import style0 from "./contractItem.vue?vue&type=style&index=0&id=bcca0d0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports